import requests from "./httpService";

const PostServices = {

  getPosts: async () => {
    try {
      const res = await requests.get(`/post`);
      return res.data;
    } catch (error) {
      throw error.response || error;
    }
  },


  // createPost: async ({ serviced, caption, images }) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("serviced", serviced);
  //     formData.append("caption", caption);
  //     if (images && images.length > 0) {
  //       images.forEach((image, index) => {
  //         formData.append("images", image); 
  //       });
  //     }
  //     const res = await requests.post(`/post`, formData, {
  //       headers: { "Content-Type": "multipart/form-data" }
  //     });

  //     return res.data;
  //   } catch (error) {
  //     throw error.response || error;
  //   }
  // },

  createPost: async (body) => {
        return requests.post(`/post`, body);
    },

  getPostById: async (id) => {
    try {
      const res = await requests.get(`/post/${id}`);
      return res.data;
    } catch (error) {
      throw error.response || error;
    }
  },
// updatePost: async (id, { serviced, caption, images }) => {
//   try {
//     const formData = new FormData();
//     formData.append("serviced", serviced);
//     formData.append("caption", caption);

//     if (images && images.length > 0) {
//       images.forEach((image) => {
//         if (image instanceof File) {
//           formData.append("images", image);
//         }
//       });
//     }
    
//     const res = await requests.put(`/post/${id}`, formData, {
//       headers: { "Content-Type": "multipart/form-data" }
//     });
    
//     // ✅ Format response to have consistent structure
//     // If API returns just the object, wrap it in standard format
//     if (res.data && res.data._id && !res.data.hasOwnProperty('status')) {
//       return {
//         status: true,
//         message: "Post updated successfully",
//         data: res.data
//       };
//     }
    
//     return res.data;
    
//   } catch (error) {
//     console.error("Update error in service:", error);
//     throw error.response?.data || error;
//   }
// },



async updatePost(id, formData) {
  const res = await requests.put(`/post/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" } 
  });
  return res;
},

deletePost: async (id) => {
        return requests.delete(`/post/${id}`);
    }

};

export default PostServices;